import { IRecipe } from "../../shared/Recipes"
import { useRef, useState } from "react"
import FormControl from "../../gui/Form/FormControl"
import { useDialog } from "../../libs/dialog/DialogProvider"
import RecipeCache from "../../data/RecipeCache"
import { useOverlay } from "../../gui/Overlay/OverlayProvider"
import DialogTitle from "../Dialogs/DialogTitle"
import Button from "../../gui/Button/Button"
import Form, { useForm } from "../../gui/Form/Form"
import Validators from "../../gui/Form/Validators"
import TextInput, { ITextInput } from "../../gui/TextInput/TextInput"
import { Formatters } from "../../gui/TextInput/TextInput"
import { useSnackbar } from "../../gui/Snackbar/SnackbarProvider"

export interface IAddRecipeProps {
    recipe?:IRecipe
}
export function AddRecipeDlg(){
    const [busy,setBusy] = useState<boolean>(false)
    const {closeDialog} = useDialog()
    const {addSnackbar} = useSnackbar()
    const {popOverlay} = useOverlay()
    const refName = useRef<ITextInput|null>(null)
    const refDesc = useRef<ITextInput|null>(null)
    const refServing = useRef<ITextInput|null>(null)

    const onClose = () => popOverlay("addRecipe")

    const {valid} = useForm()

    const onSave = async () => {
        if (!refName.current || !refDesc.current || !refServing.current) return
        try {
            setBusy(true)
            await RecipeCache.i.addRecipe(refName.current.value!, refDesc.current.value!, parseInt(refServing.current.value!)||1)
            closeDialog()
        }catch(e){
            addSnackbar(e)
        }finally{
            setBusy(false)
        }
    }
    return <>
        <DialogTitle title="Add a new recipe" onClose={onClose}/>
        <div className="content">
            <FormControl validators={[Validators.Required("Name")]}>
                <TextInput ref={refName} placeholder="Name" float={true}/>
            </FormControl>
            <FormControl validators={[Validators.Required("Description")]}>
                <TextInput className="desc" ref={refDesc} placeholder="Description" float={true} multiline={true}/>
            </FormControl>
            <FormControl validators={[Validators.Required("Servings")]}>
                <TextInput ref={refServing} placeholder="Servings" float={true} formatter={Formatters.PositiveRealNumber}/>
            </FormControl>
        </div>
        <div className="actions">
            <Button variant="text" size="regular" onClick={closeDialog}>CANCEL</Button>
            <Button variant="contained" size="regular" color="primary" onClick={onSave} disabled={busy||!valid}>SAVE</Button>
        </div>
    </>
}

export default function useAddRecipe(){
    const {addOverlay} = useOverlay()
    const addRecipe = () => addOverlay("addRecipe", {children:<Form><AddRecipeDlg/></Form>, className:"dialog popup"})
    return {addRecipe}
}